import { AnalyticsGTM } from '@quicktools/shared-components/services/analytics-gtm';
import ReactGA4 from 'react-ga4';

import { VERSION, TOOL_NAME } from '../../configs';
import { PageType } from '../../types';

class ProfilePicAnalytics extends AnalyticsGTM {
  public eventHome({ event_name, ...rest }) {
    this.sendGaEvent(event_name, {
      page_name: PageType.Landing,
      ...rest,
    });
    this.hjEvent(event_name);
    this.hjStateChange(event_name);
  }

  public eventEditor({ event_name, ...rest }) {
    this.sendGaEvent(event_name, {
      page_name: PageType.Editor,
      ...rest,
    });
    this.hjEvent(event_name);
    this.hjStateChange(event_name);
  }
}

export default new ProfilePicAnalytics(
  {
    VERSION,
    TOOL_NAME,
  },
  ReactGA4,
);
